import { AnimatePresence, motion } from 'motion/react';
import { Spinner } from './spinner';

interface ContentLoaderProps {
  show: boolean;
  title?: string;
}

export const ContentLoader: React.FC<ContentLoaderProps> = ({
  show,
  title = 'Carregando...',
}) => {
  return (
    <AnimatePresence>
      {show && (
        <motion.div
          key="loader"
          className="fixed inset-0 flex flex-col justify-center items-center bg-black/40 backdrop-blur-sm z-90"
          initial={{ opacity: 0, backdropFilter: 'blur(0px)' }}
          animate={{ opacity: 1, backdropFilter: 'blur(6px)' }}
          exit={{ opacity: 0, backdropFilter: 'blur(0px)' }}
          transition={{ duration: 0.25, ease: 'easeOut' }}
        >
          <motion.div
            initial={{ opacity: 0, scale: 0.96, y: 8 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.96, y: -8 }}
            transition={{ duration: 0.2 }}
            className="flex flex-col items-center gap-4"
          >
            <Spinner className="size-18" />

            {title && <span className="text-sm text-white/80">{title}</span>}
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
